import React from 'react'
import Header from './components/Header'
import POSTable from './components/POSTable'

export default function Pos() {
  return (
    <section>
      <Header  />
      <POSTable />
    </section>
  )
}
